import * as React from "react";
import { Icon } from "sb-resp-ui";
export class SearchBar extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.queryChangeHandler = (event) => {
            this.props.setQuery(event.target.value);
        };
    }
    render() {
        const { query, setSearchBarInput, clearQuery, isDesktop, placeholder, searchFocusHandler, hasFocus } = this.props;
        return (React.createElement("div", { className: "rj-bet-search-react-container", "data-uat": "div-search-bar-container" },
            React.createElement("div", { className: "rj-bet-search-form" },
                React.createElement("input", { id: "rj-bet-search-field", ref: setSearchBarInput, className: "rj-bet-search-field", placeholder: placeholder, type: "text", value: query, onFocus: searchFocusHandler, onChange: this.queryChangeHandler, autoComplete: "off", "data-uat": "input-search-query-input" }),
                React.createElement("label", { htmlFor: "rj-bet-search-field", className: "rj-bet-search__icon", "data-uat": "label-search-icon" },
                    React.createElement(Icon, { i: "icon i-18 i-c-search", dataUat: "span-search-icon" })),
                (isDesktop && hasFocus || query !== "") &&
                    React.createElement("div", { className: "rj-bet-search-clear", "data-uat": "div-search-clear-button", onClick: clearQuery })),
            this.props.children));
    }
    componentWillUnmount() {
        this.props.clearQuery();
    }
}
//# sourceMappingURL=SearchBar.js.map